<template>
  <div class="bootcamp-details-list">
    <div class="bootcamp-details-list__detail">
      <ProfileIcon class="bootcamp-details-list__icon" />
      <span class="bootcamp-details-list__detail-instructors">{{
        contentInstructors
      }}</span>
    </div>
    <div class="bootcamp-details-list__detail">
      <div class="bootcamp-details-list__detail--date">
        <CalendarIcon class="bootcamp-details-list__icon" />
        {{
          formatDate({
            start: bootcamp.start_datetime,
            end: bootcamp.end_datetime,
          })
        }}
        <i
          class="bootcamp__timezone-icon material-icons info-icon"
          role="presentation"
          v-tooltip="{
            content: `Local time: ${localTimeZone}`,
            placement: 'top-center',
          }"
        >
          info_outline
        </i>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileIcon from '@/assets/icons/bootcamps/instructor_icon.svg'
import CalendarIcon from '@/assets/icons/bootcamps/date_icon.svg'
import { localTimezone, bootcampCommons } from '@/helpers/mixins'

export default {
  name: 'BootcampDetailsList',
  mixins: [localTimezone, bootcampCommons],
  components: {
    CalendarIcon: { ...CalendarIcon, name: 'CalendarIcon' },
    ProfileIcon: { ...ProfileIcon, name: 'ProfileIcon' },
  },
  props: {
    bootcamp: {
      type: Object,
      required: true,
    },
    formatDate: {
      type: Function,
      required: true,
    },
  },
}
</script>

<style lang="scss">
.bootcamp-details-list {
  border-radius: 10px;
  width: 100%;
  color: var(--white);
  @include desktop {
    display: flex;
  }
  &__detail {
    display: flex;
    align-items: center;
    font-size: rem(18px);
    padding: 10px 40px;
    background: var(--darker-gray);
    flex-grow: 1;
    @include desktop {
      padding: 20px 40px;
      font-size: rem(15px);
    }
    &:nth-of-type(even) {
      background: var(--highlight-gray);
      @include desktop {
        background: var(--darker-gray);
      }
    }
    &--date {
      @include desktop {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-left: auto;
      }
    }
    &-instructors {
      font-weight: bold;
    }
  }
  &__icon {
    margin: -1px 15px 0 0;
    min-width: 25px;
  }
}
</style>
